import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { clearTenantBranding } from '../../components/common/tenantBranding';

const NoAccessPage: React.FC = () => {
  const navigate = useNavigate();

  const signOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_routes');
    localStorage.removeItem('first_page');
    localStorage.removeItem('user_uid');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    clearTenantBranding();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full rounded-2xl border border-neutral-800 bg-neutral-900 p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-indigo-900/30 text-indigo-300 flex items-center justify-center mb-5">
          <ShieldOff className="w-7 h-7" />
        </div>
        <h1 className="text-xl font-semibold text-white">You don’t have access to any page</h1>
        <p className="text-sm text-neutral-400 mt-3 leading-relaxed">
          Your portal access is active, but no routes are assigned to you yet.
          Ask an administrator to grant pages on your role or user access settings.
        </p>
        <button
          type="button"
          onClick={signOut}
          className="mt-6 px-4 py-2 rounded-lg text-sm font-medium bg-indigo-600 hover:bg-indigo-700"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default NoAccessPage;
